import { createFileRoute, redirect } from '@tanstack/react-router'
import { getUserWithProfile } from '@/lib/collections/workerProfile-Users/getUserWithProfile';
import ListVisitLog from '@/visits/visit-logs/views/user/list/listVisitLog';

export const Route = createFileRoute('/_authenticated/visitLog/$id/')({
    beforeLoad: ({ context }) => {
        if (!context.user) {
            throw redirect({ to: '/login' });
        }

        // validacion de roles permitidos
        const { isAsesorComercial, isServicioTecnico } = context.userRoles;
        if (!isAsesorComercial && !isServicioTecnico) {
            throw redirect({ to: '/unauthorized' });
        }
    },

    loader: async ({ params }) => {
        const user = await getUserWithProfile(params.id);
        if (!user) throw new Error("Usuario no encontrado");
        return user;
    },
    component: UserVisitList,
});

function UserVisitList() {
    // const user = Route.useLoaderData() as CombinedUser;
    const { id } = Route.useParams();

    return (
        <div className="container mx-auto py-6">
            {/* <VisitsList userId={id} /> */}
            <ListVisitLog userId={id} />
        </div>
    );
}